import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';


const ReportForm = () => {
  const [formData, setFormData] = useState({
    start_date: '2024-09-01',
    end_date: '2024-09-30',
    top: 5,
    type: '',
    format: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Implement form submission logic here

  };

  return (
    <Container className="mt-4" style={{ maxWidth: '600px', marginLeft: '0px' }}>
      <Form onSubmit={handleSubmit} className="p-4 border rounded" style={{ borderTop: '5px solid rgb(0, 123, 255)' }}>
        <fieldset>
          <legend>Parameters</legend>

          {/* Start Date Input */}
          <Form.Group as={Row} controlId="start_date" className="mb-4">
            <Form.Label column sm="4" title="Please choose a start date to report on">
              Start Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="date"
                name="start_date"
                value={formData.start_date}
                onChange={handleChange}
                required
                style={{ marginTop: '6px' }}
              />
            </Col>
          </Form.Group>

          {/* End Date Input */}
          <Form.Group as={Row} controlId="end_date" className="mb-4">
            <Form.Label column sm="4" title="Please choose an end date to report on">
              End Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="date"
                name="end_date"
                value={formData.end_date}
                onChange={handleChange}
                required
                style={{ marginTop: '6px' }}
              />
            </Col>
          </Form.Group>

          {/* Top Accounts Input */}
          <Form.Group as={Row} controlId="top" className="mb-4">
            <Form.Label column sm="4" title="Please choose how many of the top accounts to report on">
              Top Accounts
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="number"
                name="top"
                min="1"
                value={formData.top}
                onChange={handleChange}
                style={{ marginTop: '6px' }}
              />
            </Col>
          </Form.Group>

          {/* Type Selection */}
          <Form.Group as={Row} controlId="type" className="mb-4">
            <Form.Label column sm="4">
              Type
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="type"
                value={formData.type}
                onChange={handleChange}
                style={{ marginTop: '6px' }}
              >
                <option value="">Select Type</option>
                <option value="5">DENTIST WANTS A DIFFERENT SHADE</option>
                <option value="2">NEEDS ADJUSTING</option>
                <option value="4">NEXT PROCEDURE</option>
                <option value="1">REMAKE</option>
                <option value="3">REPAIR</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Format Selection */}
          <Form.Group as={Row} controlId="format" className="mb-4">
            <Form.Label column sm="4" title="Please choose a display format">
              Format <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="format"
                value={formData.format}
                onChange={handleChange}
                required
                style={{ marginTop: '6px' }}
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Submit Button */}
         <Form.Group as={Row}>
           <Col sm={{ span: 8, offset: 4 }}>
             <Link to="/AddNextCaseAccount">
               <Button
                 id="pay-per-task-submit"
                 type="button"
                 variant="primary"
                 className="w-100 mt-2"
                 style={{
                   backgroundColor: '#004aad',
                   borderColor: '#004aad',
                   marginTop: '10px',
                 }}
               >
                 Run
               </Button>
             </Link>
           </Col>
         </Form.Group>
        </fieldset>
      </Form>
    </Container>
  );
};

export default ReportForm;
